// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* BEM support Func\n -------------------------- */\n.anchorPoint_box {\n  width: 10rem;\n}\n.anchorPoint_box .fixed_box {\n  position: fixed;\n  top: 60px;\n  left: 0;\n  right: 0;\n  z-index: 99;\n}\n.anchorPoint_box .fixed_box_noheader {\n  position: fixed;\n  top: 0px;\n  left: 0;\n  right: 0;\n  z-index: 99;\n}\n.anchorPoint {\n  background-color: #FFFFFF;\n  padding: 36px 12px 0;\n  border-bottom: 1px solid #E1E1E1;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  overflow-x: auto;\n  overflow-y: hidden;\n}\n.anchorPoint .anchorPointItem {\n  padding-bottom: 7px;\n  margin-right: 32px;\n  border-bottom: 1px solid rgba(174, 154, 105, 0);\n  margin-bottom: -1px;\n  font-weight: 600;\n  line-height: 1.43;\n  text-decoration: none;\n  color: #000000;\n  white-space: nowrap;\n}\n.anchorPoint .anchorPointItem:last-child {\n  margin-right: 0;\n}\n.anchorPoint .anchorPointItem.active {\n  border-bottom: 2px solid #AE9A69;\n  color: #AE9A69;\n}", ""]);
// Exports
exports.locals = {
	"color_default": "#ae9a69",
	"color_default_block": "#b4a172",
	"color_default_light": "#f6f4f0",
	"color_dark": "#1e1e1e",
	"color_dark2": "#000000",
	"color_grey4": "#fbfbfd",
	"color_grey3": "#999999",
	"color_grey2": "#e1e1e1",
	"color_grey1": "#f4f4f4",
	"color_lightBg": "#F7F8FB",
	"color_white": "#FFFFFF",
	"color_uired": "#b41d23",
	"color_uigreen": "#2bb578",
	"color_fb": "#3c599b",
	"color_qq": "#68a5e1",
	"color_vx": "#4ba44c",
	"color_wb": "#ff9933"
};
module.exports = exports;
